import {
  DEFAULT_ERROR_MODAL_TITLE,
  REGISTRATION_SUPPORT_EMAIL,
  REGISTRATION_SUPPORT_PHONE,
} from "./successCopy";

/** Body copy for failed Quick Code lookup (legacy buxusweb `QuickCodeForm` parity). */
export function quickCodeLookupFailureParagraphs(): readonly string[] {
  return [
    'Please double check your Quick Code and hit "Start" again.',
    'Make sure you haven\'t typed "O" for "0" or vice-versa.',
    `If you have any issues, big or small, please contact us for help at ${REGISTRATION_SUPPORT_PHONE} or Help@Buxus.io.`,
  ];
}

/** Plain text for WebView `DISPLAY_ERROR_MODAL` and simple modal bodies. */
export function quickCodeLookupFailurePlainText(): string {
  return quickCodeLookupFailureParagraphs().join("\n\n");
}

export {
  DEFAULT_ERROR_MODAL_TITLE,
  REGISTRATION_SUPPORT_EMAIL,
  REGISTRATION_SUPPORT_PHONE,
};
